require('./brokerRightsSellView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @ actions
const brokerRightsSellActions = require('actions/brokerRightsSell');
const productFileActions = require('actions/brokerGetProductFile');
const signaturePatternActions = require('actions/signaturePattern');
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');

// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const {
    BrokerRightsSellStep1
} = require('components/broker/brokerRightsSell/brokerRightsSellSteps/brokerRightsSellStep1/brokerRightsSellStep1');
const {
    BrokerRightsSellStep2
} = require('components/broker/brokerRightsSell/brokerRightsSellSteps/brokerRightsSellStep2/brokerRightsSellStep2');
const BrokerRightsSellSuccessStep = require('components/broker/brokerRightsSell/brokerRightsSellSteps/brokerRightsSellSuccessStep/brokerRightsSellSuccessStep');
const BrokerRightsSellSidebar = require('components/broker/brokerRightsSell/brokerRightsSellSidebar/brokerRightsSellSidebar');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    HYPHEN,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_SELL_SCREEN
} = require('constants/index');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getDocumentURL } = require('utilities/stringHelper');

class BrokerRightsSellView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const { immBrokerRightsSell, immCorporatesOperations, getProductFile, setWithValidateButton, setSubscriptionInfo, history } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const isin = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex, 'isin'], false);
        const iso = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex, 'iso'], false);

        if (__CONTACT_CENTER__) {
            setWithValidateButton(false);
        }

        if (iso && isin) {
            getProductFile(isin, iso, BROKER_SELL_SCREEN);
            scrollToTop();
        } else {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        }

        const immOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            immBrokerRightsSell.get('selectedCorporateOperationIndex')
        ]);

        setSubscriptionInfo(
            immCorporatesOperations ? immCorporatesOperations.get('selectedContract').toJS() : {},
            immOperation ? immOperation.toJS() : {}
        );
    }

    componentWillUnmount() {
        const { reset, resetProductFile, setWithValidateButton } = this.props;
        if (__CONTACT_CENTER__) {
            setWithValidateButton(true);
        }
        reset();
        resetProductFile();
    }

    buildErroneous() {
        const title = formatText('broker-rightsSellErrorTitle');
        const goBackButtonLabel = formatText('broker-rightsSellGoBack').toUpperCase();
        const goBackButtonLink = `/myprofile/broker`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: goBackButtonLink
        };

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError errorMessage={title} mainButton={goBackButton}>
                        <FormattedText value="broker-rightsSellErrorMessage" />
                    </WizardError>
                </div>
            </div>
        );
    }

    buildSuccessful() {
        const { immBrokerRightsSell, immCorporatesOperations } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-xs-12">
                    <BrokerRightsSellSuccessStep
                        immBrokerRightsSell={immBrokerRightsSell}
                        immCorporatesOperations={immCorporatesOperations}
                    />
                </div>
            </div>
        );
    }

    buildWizard() {
        const {
            finish,
            handleDisclaimerCheckboxChange,
            immBrokerRightsSell,
            immBrokerSubscription,
            immCorporatesOperations,
            immFlagBasedFeatures,
            immPreContractualMail,
            immProductFile,
            immProfileFields,
            requestProfile,
            resetPrecontractualMail,
            sendPreContractualMail,
            setVisibleStep,
            setWillCancel,
            validateStep,
            setDocumentsRead,
            getExAnteData,
        } = this.props;
        const immSteps = immBrokerRightsSell.get('steps');
        const firstStepLoading = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immBrokerRightsSell.getIn(['steps', SECOND_STEP, 'loading']);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: finish,
            cancel: this.handleCancel
        };
        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const maxDate = moment(selectedCorporateOperation.get('closeDate'));
        const catalogData = immProductFile.get('catalogData');

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immBrokerRightsSell.get('visibleStep')}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={firstStepLoading || immProductFile.get('isFetching')}
                >
                    <BrokerRightsSellStep1
                        immBrokerRightsSell={immBrokerRightsSell}
                        catalogData={catalogData}
                        maxDate={maxDate}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={secondStepLoading}
                    immFinalButton="broker-rightsSellFinishLabel"
                >
                    <BrokerRightsSellStep2
                        immBrokerRightsSell={immBrokerRightsSell}
                        immCorporatesOperations={immCorporatesOperations}
                        handleDisclaimerCheckboxChange={handleDisclaimerCheckboxChange}
                        setDocumentsRead={setDocumentsRead}
                        immBrokerSubscription={immBrokerSubscription}
                        immPreContractualMail={immPreContractualMail}
                        immProfileFields={immProfileFields}
                        requestProfile={requestProfile}
                        resetPrecontractualMail={resetPrecontractualMail}
                        sendPreContractualMail={sendPreContractualMail}
                        getExAnteData={getExAnteData}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    findRights () {
        const { immMyInvestments, immBrokerRightsSell, immCorporatesOperations } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const contract = API_ENTERPRISE_NUMBER+API_CENTER+immCorporatesOperations.getIn(['selectedContract', 'cuenta', 'fullNumber']);
        const isin = selectedCorporateOperation.get('isin');
        const iso = selectedCorporateOperation.get('iso');
        const emitionCode = selectedCorporateOperation.get('codigoEmision');
        const valueCode = selectedCorporateOperation.get('codigoValorInterno');

        const contractWithRights = immMyInvestments
            .getIn(['contracts'])
            .find(immContract =>
                immContract.get('contract') === contract
            );

        const availableRights = contractWithRights ? contractWithRights
            .get('elements')
            .find(immElement =>
                immElement.get('emisionCode') === emitionCode &&
                immElement.get('isin') === isin &&
                immElement.get('iso') === iso &&
                immElement.get('valueCode') === valueCode
            ) : false;

        return availableRights ? availableRights.get('shares') : HYPHEN;
    }

    handleCancel() {
        this.props.history.replace(BROKER_CORPORATE_OPERATIONS_URL);
    }

    render() {
        const {
            immBrokerRightsSell,
            immCorporatesOperations,
            immProductFile,
            immVariables,
            immFlagBasedFeatures,
        } = this.props;
        const subtitleLeft = formatText('broker-rightsSellSubtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerCorporateOperations'),
                url: `/myprofile/broker/corporatesOperations`
            },
            {
                text: formatText('breadcrumb-brokerRightsSell')
            }
        ];
        let bodyContent;
        let commissionButton;

        if (immBrokerRightsSell.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        } else if (immBrokerRightsSell.get('submitError')) {
            bodyContent = this.buildErroneous();
        } else if (immBrokerRightsSell.get('selectedCorporateOperationIndex') !== -1) {
            const wizard = this.buildWizard();
            const quotationValue = immProductFile.getIn(['productValue', 'amount'], 0);
            const quotation = immProductFile.get('productValue').merge({
                amount: quotationValue
            });
            const quotationDate = immProductFile.get('updatePriceDate');
            const quotationTime = immProductFile.get('updatePriceTime');
            const availableRights = this.findRights();
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));

            bodyContent = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {wizard}
                    </div>
                    <div className="col-xs-4" id="printable-wizard">
                        <BrokerRightsSellSidebar
                            immBrokerRightsSell={immBrokerRightsSell}
                            immCorporatesOperations={immCorporatesOperations}
                            quotation={quotation}
                            quotationDate={quotationDate}
                            quotationTime={quotationTime}
                            availableRights={availableRights}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                        />
                    </div>
                </div>
            );

            commissionButton = (
                <OKLink
                    inverse={true}
                    modifier="complementary"
                    target="_blank"
                    to={fees_url}
                >
                    <FormattedText value="broker-rightsSellCommissions" />
                </OKLink>
            );
        }

        return (
            <article className="broker-rights-sell">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        breadcrumbConfig={mappingBreadcrumb}
                        titleKey="broker-rightsSellTitle"
                        subtitleLeft={subtitleLeft}
                    >
                        {commissionButton}
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
                <section className="broker-rights-sell__body">
                    {bodyContent}
                </section>
            </article>
        );
    }
}

BrokerRightsSellView.propTypes = {
    finish: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    handleDisclaimerCheckboxChange: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerRightsSell: PropTypes.object.isRequired,
    immBrokerSubscription: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetProductFile: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setSubscriptionInfo: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWithValidateButton: PropTypes.func,
    setDocumentsRead: PropTypes.func.isRequired,
    getExAnteData: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerRightsSellView;
module.exports.BrokerRightsSellView = connect(
    state => ({
        immBrokerRightsSell: state.brokerRightsSell,
        immBrokerSubscription: state.brokerSubscription,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immMyInvestments: state.brokerMyInvestments,
        immPreContractualMail: state.preContractualMail,
        immProfileFields: state.profile,
        immProductFile: state.brokerProductFile,
        immVariables: state.globalVariables,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        finish: brokerRightsSellActions.finish,
        getProductFile: productFileActions.getProductFileWithCatalogData,
        handleDisclaimerCheckboxChange: brokerRightsSellActions.toggleDisclaimerCheckbox,
        requestProfile: profileActions.requestProfile,
        reset: brokerRightsSellActions.reset,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetProductFile: productFileActions.reset,
        sendPreContractualMail: preContractualMailActions.sendBrokerPreContractualMail,
        setSubscriptionInfo: BrokerSubscriptionActions.setSubscriptionInfo,
        setVisibleStep: brokerRightsSellActions.setVisibleStep,
        setWillCancel: brokerRightsSellActions.setWillCancel,
        validateStep: brokerRightsSellActions.validateStep,
        setWithValidateButton: signaturePatternActions.setWithValidateButton,
        setDocumentsRead: brokerRightsSellActions.setDocumentsRead,
        getExAnteData: brokerRightsSellActions.getExAnteData,
    }
)(withRouter(BrokerRightsSellView));
